var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileupload(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112.8 54.6C108.6 49.2 102 45 95.4 43.2C93.6 25.8 78 12 60 12C43.8 12 30 22.8 25.8 37.8C10.8 42 0 55.8 0 72C0 91.8 16.2 108 36 108C39.6 108 42 105.6 42 102C42 98.4 39.6 96 36 96C22.8 96 12 85.2 12 72C12 60.6 20.4 50.4 31.8 48.6C34.2 48 36 46.2 36.6 43.8C38.4 32.4 48.6 24 60 24C73.2 24 84 34.8 84 48C84 51 86.4 53.4 89.4 54C94.8 54.6 100.2 57.6 103.8 61.8C107.4 66 108.6 72 108 77.4C106.8 87.6 97.2 95.4 86.4 95.4H72C68.4 95.4 66 93 66 89.4V71.4H76.2C78 71.4 78.6 69.6 77.4 68.4L61.2 54C60.6 54 59.4 54 58.8 54.6L42.6 69C41.4 70.2 42 72 43.8 72H54V90C54 100.2 61.8 108 72 108H85.8C103.2 108 117.6 95.4 119.4 79.2C120.6 70.2 118.2 61.8 112.8 54.6Z",
    fill: "#15803D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileupload);
export default __webpack_public_path__ + "static/media/fileupload.7c059767876ded74dbea7aedef42a5bc.svg";
export { ForwardRef as ReactComponent };